import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ForbiddenDetectorStateProps {
  show403Dialog: boolean;
}
const initialState: ForbiddenDetectorStateProps = {
  // ...existing state...
  show403Dialog: false,
};

const forbiddenDetectorSlice = createSlice({
  name: 'forbiddenDetector',
  initialState,
  reducers: {
    setShow403Dialog(state, action) {
      state.show403Dialog = action.payload;
    },
  },
});

export const { setShow403Dialog } = forbiddenDetectorSlice.actions;
export default forbiddenDetectorSlice.reducer;
